import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-stars" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Color Fact! ")
const _hoisted_3 = { class: "k-color-fact-container" }
const _hoisted_4 = { class: "k-color-fact-text" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "k-color-fact-title" }, "Did you know?", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "k-color-fact-posttext" }, "Wow!", -1)

import NavigableScreen from 'components/navigable-screen.vue';
    import NavButton from 'components/nav-button.vue';
    import { useModule } from 'src/modules/modules';
    import { ColorFacts } from 'src/color-facts';
    import sample from 'lodash/sample'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'color-fact-menu',
  emits: ['back'],
  setup(__props, { emit }) {

_useCssVars(_ctx => ({
  "3189f86e": (_unref(theme).theme.titleBg)
}))

    const { global, theme } = useModule();

    const confirmText = [
        'WOWZA!',
        'NEATO!',
        'YABA DABA DOO!',
        'JENGA!',
        'HOLY MOLY!',
        'HOT DOG!',
        'HOT TAMALES!',
        'HOT DIGGITY!',
        'YEE HAW!',
        'YIPPEE!',
        'WOAH!',
        'WOW!',
        'WOWIE!',
        'WOWZERS!',
        'This is BIG!',
        'Learning so much!',
        'Thank you Dr. Color!',
        'BANANAS!',
        'So wise!',
        'Sloop Diggity!'
    ]

    const getUniqueFact = () : string => {
        if (global.colorFactsSeen.length === ColorFacts.length) {
            global.colorFactsSeen = [];
        }

        let fact = sample(ColorFacts)!;
        if (global.colorFactsSeen.includes(fact)){
            return getUniqueFact();
        }

        global.colorFactsSeen.push(fact);
        return fact;
    }

    const colorFact = getUniqueFact();
    
    
    const handleNativeBack = () => emit('back');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NavigableScreen, {
    "use-banner-offset": "",
    onNativeBack: handleNativeBack
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    content: _withCtx(() => [
      _createVNode(_Transition, {
        name: "slide-fade",
        appear: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_unref(colorFact)) + " ", 1),
              _hoisted_6
            ])
          ])
        ]),
        _: 1
      })
    ]),
    "nav-center": _withCtx(() => [
      _createVNode(NavButton, {
        type: "back",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('back')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(sample)(confirmText)), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})